import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { RecalProposalSetRepoImpl } from "domain/repository/RecalProposalSet/RecalProposalSetRepoImpl";
import { useRecalProposalSetTracked } from "presentation/store/RecalProposalSet/RecalProposalSetProvider";
import { RecalProposalSetVM } from "presentation/viewModel/RecalProposalSet/RecalProposalSetVM";
import { useMemo } from "react";

export const useRecalProposalSetVM = () => {
    const [, setRecalProposalSetState] = useRecalProposalSetTracked();
    const recalProposalSetVM = useMemo(() =>
        RecalProposalSetVM({
            dispatch: [setRecalProposalSetState],
            recalProposalSetRepo: RecalProposalSetRepoImpl(),
            companyRepo: CompanyRepoImpl(),
        }), [setRecalProposalSetState])

    return recalProposalSetVM
}